import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c863b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-btn" }
const _hoisted_2 = { class: "button-box" }


import KiliButton from "@/components/KiliButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'afterBottomBtn',
  props: {
    btnData: {
        type: Array,
        default: () => {
            return [
                {
                    plain: true,
                    textColor: '#333333',
                    bordersColor: '#999999',
                    radiusSize: '6px',
                    title: 'Cancel',
                },
                {
                    plain: false,
                    textColor: '#E04545',
                    bordersColor: '#E04545',
                    radiusSize: '6px',
                    title: 'Apply',
                    loading:false
                },
            ]
        }
    }
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props



const handleBtn = (item: any) => {
    emit('click', item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.btnData, (btn, index) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (btn.plain)
          ? (_openBlock(), _createBlock(KiliButton, {
              key: 0,
              plain: "",
              icon: btn.icon,
              textColor: btn.textColor,
              bordersColor: btn.bordersColor,
              radiusSize: btn.radiusSize,
              title: btn.title,
              loading: btn.loading,
              onClick: ($event: any) => (handleBtn(btn))
            }, null, 8, ["icon", "textColor", "bordersColor", "radiusSize", "title", "loading", "onClick"]))
          : (_openBlock(), _createBlock(KiliButton, {
              key: 1,
              icon: btn.icon,
              textColor: btn.textColor,
              bordersColor: btn.bordersColor,
              radiusSize: btn.radiusSize,
              title: btn.title,
              loading: btn.loading,
              onClick: ($event: any) => (handleBtn(btn))
            }, null, 8, ["icon", "textColor", "bordersColor", "radiusSize", "title", "loading", "onClick"]))
      ]))
    }), 256))
  ]))
}
}

})